<template>
  <div id="invoiceQuery">
    <div class="query">
      <div class="invoice">
        <el-card class="box-card" v-for="item in invoiceList" :key="item.id">
          <van-cell
            :title="item.invoiceChannel"
            is-link
            @click="invoiceDetail(item)"
          />
        </el-card>
      </div>
      <div class="consult">
        <div>
          如仍有疑问，仍无法解决，点击咨询
          <span @click="service" style="color: #2485e6">人工客服</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "invoiceQuery",
  data() {
    return {
      goods: "",
      invoiceList: [],
      invoiceInfo: {}
    };
  },
  created() {},
  mounted() {
    this.getInvoiceList();
  },
  methods: {
    // 获取发票
    getInvoiceList() {
      apis.invoicesList().then(res => {
        if (res.code === 200) {
          this.invoiceList = res.data;
        }
      });
    },
    // 发票详情
    invoiceDetail(item) {
      this.$router.push(`/gzh/mobile/electronicInvoice`);
      this.invoiceInfo = item;
      sessionStorage.setItem("invoiceInfo", JSON.stringify(item));
    },
    // 人工客服
    service() {
      // window.open("https://work.weixin.qq.com/kfid/kfc8970885ac4a02586");
      window.open("https://work.weixin.qq.com/kfid/kfcfce44ed386dd434f");
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #invoiceQuery {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #invoiceQuery {
    width: 276px * $zoom;
  }
}
#invoiceQuery {
  font-size: 16px * $zoom;
  display: flex;
  flex-direction: column;
  align-items: center;
  .query {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .invoice {
      width: 100%;
      padding: 60px 30px 0 30px;
      flex: 1;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      ::v-deep .el-card {
        border-radius: 15px;
        margin-bottom: 27px;
        .el-card__body {
          padding: 0;
        }
      }
    }
    .consult {
      height: 60px;
      line-height: 60px;
      font-size: 22px;
      color: #848485;
      div {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
